function openTab(evt, tabIndex) {
  if(window.innerWidth > 768) {
    // Hide all tab content
    var tabContents = document.getElementsByClassName("tab-content");
    for (var i = 0; i < tabContents.length; i++) {
      tabContents[i].style.display = "none";
    }
    
    // Deactivate all tab buttons
    var tabButtons = document.getElementsByClassName("tab-button");
    for (var i = 0; i < tabButtons.length; i++) {
      tabButtons[i].classList.remove("active");
    }
    
    // Show the selected tab content and activate the button
    tabContents[tabIndex].style.display = "block";
    tabButtons[tabIndex].classList.add("active");
  }
}

$(document).ready(function() {
  /* the viewport is less than 768 pixels wide */
  if(window.innerWidth < 768) {
    initializeTabsSlider();
  }
});

$(window).resize(function(e){
  if(window.innerWidth > 768) {
    if($('.tab-buttons').hasClass('slick-initialized')){
        $('.tab-buttons').slick('unslick');
    }
  } else {
    if(!$('.slider').hasClass('slick-initialized')){
      initializeTabsSlider();
    }
  }
});
function initializeTabsSlider() {
  $('.tab-buttons').slick({
    centerMode: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    focusOnSelect: true,
    arrows: false,
    variableWidth: true,
    asNavFor: '.tabs-container'
  });
  $('.tabs-container').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    adaptiveHeight: true,
    asNavFor: '.tab-buttons'
  });
}